import { Directive, ElementRef, Renderer2, Injector, ComponentFactoryResolver, ViewContainerRef, NgZone, Inject, ChangeDetectorRef, ApplicationRef, Input, Output, NgModule, EventEmitter, Component, ViewChild, Pipe, Injectable, LOCALE_ID } from '@angular/core';
import { NgbTooltip, NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT, CommonModule as CommonModule$1 } from '@angular/common';
import { PopupModule as PopupModule$1 } from '@progress/kendo-angular-popup';
import { Subject } from 'rxjs';
import '@progress/kendo-angular-intl/locales/es/calendar';
import '@progress/kendo-angular-intl/locales/ca/calendar';
import '@progress/kendo-angular-intl/locales/es/numbers';
import '@progress/kendo-angular-intl/locales/ca/numbers';
import { DateTime as DateTime$1, Duration } from 'luxon';
import { CldrIntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';

/** Directiva que para declarar un tooltip en el elemento HTML donde se declare
 *
 * @example
 * <div [ngwkTooltip]='tooltip'></div>
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@progress/kendo-angular-popup';

const _c0 = ["kendoPopup"];
function PopupComponent_kendo_popup_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "kendo-popup", 1, 2);
    ɵngcc0.ɵɵlistener("open", function PopupComponent_kendo_popup_0_Template_kendo_popup_open_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onOpen(); })("close", function PopupComponent_kendo_popup_0_Template_kendo_popup_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onClose(); })("anchorViewportLeave", function PopupComponent_kendo_popup_0_Template_kendo_popup_anchorViewportLeave_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onAnchorViewportLeave(); });
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("anchor", ctx_r0.anchor)("margin", ctx_r0.margin)("anchorAlign", ctx_r0.anchorAlign)("popupAlign", ctx_r0.popupAlign)("popupClass", ctx_r0.popupClass);
} }
const _c1 = ["*"];
class NgwkTooltipDirective extends NgbTooltip {
    /** @ignore */
    constructor(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, _ngZone, _document, _changeDetector, _applicationRef) {
        super(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, _ngZone, _document, _changeDetector, _applicationRef);
    }
    ngOnInit() {
        super.ngOnInit();
        this.container = 'body';
    }
    /**
     * Permite obtener la posición del del tooltip. Por defecto está en 'auto'
     */
    get ngwkTooltipPosition() {
        return this.placement;
    }
    /**
     * Permite definir la posición del del tooltip. Por defecto está en 'auto'
     *
     * @param value La posición del del tooltip
     */
    set ngwkTooltipPosition(position) {
        this.placement = position;
    }
    /**
     * Permite consultar si el tooltip está habilitado o deshabilitado. Por defecto está habilitado
     */
    get ngwkTooltipDisable() {
        return this.disableTooltip;
    }
    /**
     * Permite habilitar o deshabilitar el tooltip. Por defecto está habilitado
     *
     * @param value Valor que habilita o deshabilita el tooltip
     */
    set ngwkTooltipDisable(value) {
        this.disableTooltip = value;
    }
    /**
     * Permite obtener los triggers del tooltip
     */
    get ngwkTooltipTriggers() {
        return this.triggers;
    }
    /**
     * Permite definir los triggers del tooltip
     *
     * @param value Los triggers del tooltip
     */
    set ngwkTooltipTriggers(value) {
        this.triggers = value;
    }
    /**
     * Permite obtener el tooltip. Puede ser un string o una template
     */
    get ngwkTooltip() {
        return this.ngbTooltip;
    }
    /**
     * Permite definir el tooltip. Puede ser un string o una template
     *
     * @param value El tooltip de tipo string o template
     */
    set ngwkTooltip(value) {
        this.ngbTooltip = value;
    }
    /**
     * Permite obtener la configuración de autoclose del tooltip. Por defecto está a true, haciendo que se cierre al hacer mouseleave
     * en el elemento HTML que tiene el tooltip. La configuración 'inside' permite cerrar el tooltip cuando se hace click dentro
     * de éste y la de 'outside' cuando se hace click fuera de éste.
     */
    get ngwkAutoClose() {
        return this.autoClose;
    }
    /**
     * Permite definir la configuración de autoclose del tooltip. Por defecto está a true, haciendo que se cierre al hacer mouseleave
     * en el elemento HTML que tiene el tooltip. La configuración 'inside' permite cerrar el tooltip cuando se hace click dentro
     * de éste y la de 'outside' cuando se hace click fuera de éste.
     *
     * @param value La configuración de autoclose del tooltip
     */
    set ngwkAutoClose(value) {
        this.autoClose = value;
    }
    /**
     * Permite obtener la clase que customiza el tooltip
     */
    get ngwkTooltipClass() {
        return this.tooltipClass;
    }
    /**
     * Permite definir la clase que customiza el tooltip
     *
     * @param value La clase que customiza el tooltip
     */
    set ngwkTooltipClass(value) {
        this.tooltipClass = value;
    }
    get ngwkTooltipShown() {
        return this.shown;
    }
    get ngwkTooltipHidden() {
        return this.hidden;
    }
}
NgwkTooltipDirective.ɵfac = function NgwkTooltipDirective_Factory(t) { return new (t || NgwkTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbTooltipConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ApplicationRef)); };
NgwkTooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgwkTooltipDirective, selectors: [["", "ngwkTooltip", ""]], inputs: { ngwkTooltipPosition: "ngwkTooltipPosition", ngwkTooltipDisable: "ngwkTooltipDisable", ngwkTooltipTriggers: "ngwkTooltipTriggers", ngwkTooltip: "ngwkTooltip", ngwkAutoClose: "ngwkAutoClose", ngwkTooltipClass: "ngwkTooltipClass" }, outputs: { ngwkTooltipShown: "ngwkTooltipShown", ngwkTooltipHidden: "ngwkTooltipHidden" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
NgwkTooltipDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: Injector },
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef },
    { type: NgbTooltipConfig },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ChangeDetectorRef },
    { type: ApplicationRef }
];
NgwkTooltipDirective.propDecorators = {
    ngwkTooltipPosition: [{ type: Input }],
    ngwkTooltipDisable: [{ type: Input }],
    ngwkTooltipTriggers: [{ type: Input }],
    ngwkTooltip: [{ type: Input }],
    ngwkAutoClose: [{ type: Input }],
    ngwkTooltipClass: [{ type: Input }],
    ngwkTooltipShown: [{ type: Output }],
    ngwkTooltipHidden: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgwkTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[ngwkTooltip]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc1.NgbTooltipConfig }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ApplicationRef }]; }, { ngwkTooltipPosition: [{
            type: Input
        }], ngwkTooltipDisable: [{
            type: Input
        }], ngwkTooltipTriggers: [{
            type: Input
        }], ngwkTooltip: [{
            type: Input
        }], ngwkAutoClose: [{
            type: Input
        }], ngwkTooltipClass: [{
            type: Input
        }], ngwkTooltipShown: [{
            type: Output
        }], ngwkTooltipHidden: [{
            type: Output
        }] }); })();

class TooltipModule {
}
TooltipModule.ɵfac = function TooltipModule_Factory(t) { return new (t || TooltipModule)(); };
TooltipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TooltipModule });
TooltipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            NgbTooltipModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipModule, [{
        type: NgModule,
        args: [{
                imports: [
                    NgbTooltipModule
                ],
                exports: [NgwkTooltipDirective],
                declarations: [NgwkTooltipDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TooltipModule, { declarations: function () { return [NgwkTooltipDirective]; }, imports: function () { return [NgbTooltipModule]; }, exports: function () { return [NgwkTooltipDirective]; } }); })();

/**
 * Este componente se utiliza para la declaración de un Popup, el cual depende de otro elemento HTML a modo de anchor.
 * También se le pueden definir unos margins y aligns a través de el Input 'margin' de tipo [NgwkPopupMargin]{@link NgwkPopupMargin}
 * y los inputs 'anchorAlign' y 'popupAlign' de tipo [NgwkPopupAlign]{@link NgwkPopupAlign}
 *
 * @example
 * <ngwk-popup *ngIf='isMenuOpen'
 *  [anchor]='anchor'
 *  [margin]='marginAlign'
 *  [anchorAlign]='anchorAlign'
 *  [popupAlign]='popupAlign'
 *  (close)='onClose()'
 *  (open)='onOpen()'>
 *    Content
 *  </ngwk-popup>
 *
 */
class PopupComponent {
    constructor() {
        //#region Privates
        this._anchor = null;
        this._showPopup = true;
        this._margin = { horizontal: 0, vertical: 0 };
        this._anchorAlign = {
            horizontal: 'right',
            vertical: 'bottom'
        };
        this._popupAlign = {
            horizontal: 'right',
            vertical: 'top'
        };
        this._popupClass = 'menuPopupContainer';
        this._open = new EventEmitter();
        this._close = new EventEmitter();
        this._popup = null;
        //#endregion
    }
    //#endregion
    //#region Public Methods
    /** @ignore */
    onOpen() {
        this._open.emit();
    }
    /** @ignore */
    onClose() {
        this._close.emit();
    }
    /** @ignore */
    onAnchorViewportLeave() {
        this._showPopup = false;
        this._close.emit();
    }
    //#endregion
    //#region Inputs & Outputs
    /** @ignore */
    get showPopup() {
        return this._showPopup;
    }
    /**
     * Permite obtener el anchor al cual estará anclado el Popup
     */
    get anchor() {
        return this._anchor;
    }
    /**
     * Permite definir el anchor al cual estará anclado el Popup
     *
     * @param value El anchor al cual estará anclado el Popup
     */
    set anchor(value) {
        this._anchor = value;
    }
    /**
     * Permite obtener el margen del Popup. Este margen es de tipo [NgwkPopupMargin]{@link NgwkPopupMargin}
     */
    get margin() {
        return this._margin;
    }
    /**
     * Permite definir el margen del Popup. Este margen es de tipo [NgwkPopupMargin]{@link NgwkPopupMargin}
     *
     * @param value El margen del Popup
     */
    set margin(value) {
        this._margin = value;
    }
    /**
     * Permite obtener el alineamiento respecto al anchor del Popup. Este alineamiento es de tipo [NgwkPopupAlign]{@link NgwkPopupAlign}
     */
    get anchorAlign() {
        return this._anchorAlign;
    }
    /**
     * Permite definir el alineamiento respecto al anchor del Popup. Este alineamiento es de tipo [NgwkPopupAlign]{@link NgwkPopupAlign}
     *
     * @param value El alineamiento respecto al anchor del Popup
     */
    set anchorAlign(value) {
        this._anchorAlign = value;
    }
    /**
     * Permite obtener el alineamiento respecto al propio Popup. Este alineamiento es de tipo [NgwkPopupAlign]{@link NgwkPopupAlign}
     */
    get popupAlign() {
        return this._popupAlign;
    }
    /**
     * Permite definir el alineamiento respecto al propio Popup. Este alineamiento es de tipo [NgwkPopupAlign]{@link NgwkPopupAlign}
     *
     * @param value El alineamiento respecto al propio Popup
     */
    set popupAlign(value) {
        this._popupAlign = value;
    }
    /**
     * Permite obtener la clase decoradora principal del Popup
     */
    get popupClass() {
        return this._popupClass;
    }
    /**
     * Permite definir la clase decoradora principal del Popup
     *
     * @param value La clase decoradora principal del Popup
     */
    set popupClass(value) {
        this._popupClass = value;
    }
    /**
     * Emite un evento cuando cambia el Popup cambia el estado a abierto
     */
    get open() {
        return this._open;
    }
    /**
     * Emite un evento cuando cambia el Popup cambia el estado a cerrado
     */
    get close() {
        return this._close;
    }
}
PopupComponent.ɵfac = function PopupComponent_Factory(t) { return new (t || PopupComponent)(); };
PopupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopupComponent, selectors: [["ngwk-popup"]], viewQuery: function PopupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._popup = _t.first);
    } }, inputs: { anchor: "anchor", margin: "margin", anchorAlign: "anchorAlign", popupAlign: "popupAlign", popupClass: "popupClass" }, outputs: { open: "open", close: "close" }, ngContentSelectors: _c1, decls: 1, vars: 1, consts: [[3, "anchor", "margin", "anchorAlign", "popupAlign", "popupClass", "open", "close", "anchorViewportLeave", 4, "ngIf"], [3, "anchor", "margin", "anchorAlign", "popupAlign", "popupClass", "open", "close", "anchorViewportLeave"], ["kendoPopup", ""]], template: function PopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, PopupComponent_kendo_popup_0_Template, 3, 5, "kendo-popup", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPopup);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.PopupComponent], styles: ["[_nghost-%COMP%]     .menuPopupContainer{background:transparent;border:none;margin:4px;top:50px;padding-bottom:0}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent{border-radius:6px!important;background-clip:content-box;background-color:#fff;box-shadow:0 2px 4px #0000004d,0 4px 5px #0000000f;border-radius:6px;border:none;margin:4px;text-align:middle;min-width:160px;top:50px;font-size:13px;color:#444;padding-bottom:0}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent button{text-align:left!important;background:transparent;padding:8px 11px;border-top:1px solid #ccc;border:none;border-bottom:none!important;color:#474747;cursor:pointer}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent button:hover{background-color:#f1f1f1}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent button[disabled]{opacity:.5;cursor:default!important;pointer-events:none}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent.verticalLayout{width:unset}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent>:first-child{border-radius:6px 6px 0 0;overflow-x:hidden}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent>:last-child{border-radius:0 0 6px 6px;overflow-x:hidden}[_nghost-%COMP%]     .menuPopupContainer .menuPopupContent>:only-child{border-radius:6px}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent{border-radius:6px!important;background-clip:content-box;background-color:#fff;box-shadow:0 2px 4px #0000004d,0 4px 5px #0000000f;border-radius:6px;border:none;margin:4px;text-align:middle;top:50px;font-size:13px;color:#444;padding-bottom:0}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent button{text-align:left!important;background:transparent;padding:8px 11px;border-top:1px solid #ccc;border:none;border-bottom:none!important;color:#474747;cursor:pointer}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent button:hover{background-color:#f1f1f1}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent button[disabled]{opacity:.5;cursor:default!important;pointer-events:none}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent.verticalLayout{width:unset}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent>:first-child{border-radius:6px 6px 0 0;overflow-x:hidden}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent>:last-child{border-radius:0 0 6px 6px;overflow-x:hidden}[_nghost-%COMP%]     .menuPopupContainer .notificationsContent>:only-child{border-radius:6px}[_nghost-%COMP%]     .textareaCellEditorPopupContainer{background:transparent;border:none;margin:0;width:100%}[_nghost-%COMP%]     .textareaCellEditorPopupContainer .textareaCellEditorPopupContent{border:none;font-size:13px;color:#444}"] });
PopupComponent.propDecorators = {
    _popup: [{ type: ViewChild, args: ['kendoPopup',] }],
    anchor: [{ type: Input }],
    margin: [{ type: Input }],
    anchorAlign: [{ type: Input }],
    popupAlign: [{ type: Input }],
    popupClass: [{ type: Input }],
    open: [{ type: Output }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopupComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-popup',
                template: "<kendo-popup #kendoPopup\r\n  *ngIf=\"showPopup\"\r\n  [anchor]=\"anchor\"\r\n  [margin]=\"margin\"\r\n  [anchorAlign]=\"anchorAlign\"\r\n  [popupAlign]=\"popupAlign\" \r\n  [popupClass]=\"popupClass\"\r\n  (open)=\"onOpen()\" \r\n  (close)=\"onClose()\" \r\n  (anchorViewportLeave)=\"onAnchorViewportLeave()\">\r\n    <ng-content></ng-content>\r\n</kendo-popup>",
                styles: [":host ::ng-deep .menuPopupContainer{background:transparent;border:none;margin:4px;top:50px;padding-bottom:0}:host ::ng-deep .menuPopupContainer .menuPopupContent{border-radius:6px!important;background-clip:content-box;background-color:#fff;box-shadow:0 2px 4px #0000004d,0 4px 5px #0000000f;border-radius:6px;border:none;margin:4px;text-align:middle;min-width:160px;top:50px;font-size:13px;color:#444;padding-bottom:0}:host ::ng-deep .menuPopupContainer .menuPopupContent button{text-align:left!important;background:transparent;padding:8px 11px;border-top:1px solid #ccc;border:none;border-bottom:none!important;color:#474747;cursor:pointer}:host ::ng-deep .menuPopupContainer .menuPopupContent button:hover{background-color:#f1f1f1}:host ::ng-deep .menuPopupContainer .menuPopupContent button[disabled]{opacity:.5;cursor:default!important;pointer-events:none}:host ::ng-deep .menuPopupContainer .menuPopupContent.verticalLayout{width:unset}:host ::ng-deep .menuPopupContainer .menuPopupContent>:first-child{border-radius:6px 6px 0 0;overflow-x:hidden}:host ::ng-deep .menuPopupContainer .menuPopupContent>:last-child{border-radius:0 0 6px 6px;overflow-x:hidden}:host ::ng-deep .menuPopupContainer .menuPopupContent>:only-child{border-radius:6px}:host ::ng-deep .menuPopupContainer .notificationsContent{border-radius:6px!important;background-clip:content-box;background-color:#fff;box-shadow:0 2px 4px #0000004d,0 4px 5px #0000000f;border-radius:6px;border:none;margin:4px;text-align:middle;top:50px;font-size:13px;color:#444;padding-bottom:0}:host ::ng-deep .menuPopupContainer .notificationsContent button{text-align:left!important;background:transparent;padding:8px 11px;border-top:1px solid #ccc;border:none;border-bottom:none!important;color:#474747;cursor:pointer}:host ::ng-deep .menuPopupContainer .notificationsContent button:hover{background-color:#f1f1f1}:host ::ng-deep .menuPopupContainer .notificationsContent button[disabled]{opacity:.5;cursor:default!important;pointer-events:none}:host ::ng-deep .menuPopupContainer .notificationsContent.verticalLayout{width:unset}:host ::ng-deep .menuPopupContainer .notificationsContent>:first-child{border-radius:6px 6px 0 0;overflow-x:hidden}:host ::ng-deep .menuPopupContainer .notificationsContent>:last-child{border-radius:0 0 6px 6px;overflow-x:hidden}:host ::ng-deep .menuPopupContainer .notificationsContent>:only-child{border-radius:6px}:host ::ng-deep .textareaCellEditorPopupContainer{background:transparent;border:none;margin:0;width:100%}:host ::ng-deep .textareaCellEditorPopupContainer .textareaCellEditorPopupContent{border:none;font-size:13px;color:#444}\n"]
            }]
    }], function () { return []; }, { _popup: [{
            type: ViewChild,
            args: ['kendoPopup']
        }], anchor: [{
            type: Input
        }], margin: [{
            type: Input
        }], anchorAlign: [{
            type: Input
        }], popupAlign: [{
            type: Input
        }], popupClass: [{
            type: Input
        }], open: [{
            type: Output
        }], close: [{
            type: Output
        }] }); })();

class PopupModule {
}
PopupModule.ɵfac = function PopupModule_Factory(t) { return new (t || PopupModule)(); };
PopupModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PopupModule });
PopupModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule$1,
            PopupModule$1
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopupModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule$1,
                    PopupModule$1
                ],
                declarations: [
                    PopupComponent
                ],
                exports: [
                    PopupComponent
                ],
                entryComponents: [
                    PopupComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PopupModule, { declarations: function () { return [PopupComponent]; }, imports: function () { return [CommonModule$1,
        PopupModule$1]; }, exports: function () { return [PopupComponent]; } }); })();

var LocaleFormat;
(function (LocaleFormat) {
    LocaleFormat[LocaleFormat["None"] = 1] = "None";
    LocaleFormat[LocaleFormat["Lower"] = 2] = "Lower";
    LocaleFormat[LocaleFormat["Upper"] = 3] = "Upper";
})(LocaleFormat || (LocaleFormat = {}));

// @dynamic
// fix: https://github.com/ng-packagr/ng-packagr/issues/696
/**
 * Servicio de los Locale de la aplicación
 */
class LocaleService {
    constructor() {
        this._locales = new Map();
        this._currentCulture = 'es-ES';
        this._currentCultureUI = 'es-ES';
        this._cultureChange$ = new Subject();
        this._cultureUIChange$ = new Subject();
    }
    /**
     * Método que permite declarar un nuevo locale con una serie de traducciones pasado por el parámetro 'data'
     *
     * @param locale Nuevo locale a incluir en la aplicación
     * @param data Datos relacionados con el locale a incluir
     */
    setLocale(locale, data) {
        this.instance._locales.set(locale, data);
    }
    /**
     * Método que permite obtener un locale en minúsculas a través del identificador pasado como parámetro 'key'
     *
     * @param key Identificador del locale
     */
    getLowerLocaleString(key) {
        return this.getLocaleString(key, LocaleFormat.Lower);
    }
    /**
     * Método que permite obtener un locale en mayúsculas a través del identificador pasado como parámetro 'key'
     *
     * @param key Identificador del locale
     */
    getUpperLocaleString(key) {
        return this.getLocaleString(key, LocaleFormat.Upper);
    }
    /**
     * Método que permite obtener un locale a través del identificador pasado como parámetro 'key'
     *
     * @param key Identificador del locale
     * @param format Formato del locale
     */
    getLocaleString(key, format = LocaleFormat.None) {
        let value = null;
        if (this.instance._locales.has(this.instance._currentCultureUI)) {
            let data = this.instance._locales.get(this.instance._currentCultureUI);
            if (data) {
                value = data[key];
                if (value) {
                    switch (format) {
                        case LocaleFormat.Lower:
                            value = value.toLowerCase();
                            break;
                        case LocaleFormat.Upper:
                            value = value.toUpperCase();
                            break;
                    }
                }
            }
        }
        if (value) {
            return value;
        }
        else {
            return `{{${key}}}`;
        }
    }
    /**
     * Permite saber si el locale con identificador 'id' se incluye en el listado de locales
     *
     * @param id Identificador del locale
     */
    containsLocale(id) {
        return this.instance._locales && this.instance._locales.has(id);
    }
    /**
     * Método para cambiar de cultura en la aplicación. Es la cultura con la que se mostrarán los textos en la aplicación
     *
     * @param locale Nueva cultura a cambiar en la aplicación
     */
    onCultureChange(locale) {
        this._cultureChange$.next(locale);
    }
    /**
     * Método para cambiar de cultura UI en la aplicación. Es la cultura con la que se mostrarán los textos en la aplicación
     *
     * @param locale Nueva cultura UI a cambiar en la aplicación
     */
    onCultureUIChange(locale) {
        this._cultureUIChange$.next(locale);
    }
    /**
     * Setter currentCultureUI: Cultura con la se mostraran los textos de la aplicación.
     * @return
     */
    set currentCultureUI(cultureUI) {
        this.instance._currentCultureUI = cultureUI;
        this.onCultureUIChange(cultureUI);
    }
    /**
     * Getter currentCultureUI: Cultura con la se mostraran los textos de la aplicación.
     * @return
     */
    get currentCultureUI() {
        return this.instance._currentCultureUI;
    }
    /**
     * Setter currentCulture: Cultura con la se formataran los datos (numeros, moneda, fecha, etc) de la aplicación.
     * @return
     */
    set currentCulture(culture) {
        this.instance._currentCulture = culture;
        this.onCultureChange(culture);
    }
    /**
     * Getter currentCulture: Cultura con la se formataran los datos (numeros, moneda, fecha, etc) de la aplicación.
     * @return
     */
    get currentCulture() {
        return this.instance._currentCulture;
    }
    /**
     * Método que permite obtener la instancia actual de Locale
     */
    get instance() {
        return LocaleService.current;
    }
    /**
     * Método que permite obtener la instancia actual de Locale. Si no hay ninguna definida se retorna una nueva
     */
    static get current() {
        if (!LocaleService._current) {
            LocaleService._current = new LocaleService();
        }
        return LocaleService._current;
    }
    /**
     * Retorna un observable que permite saber cuando se ha cambiado de cultura en la aplicación
     */
    get onCultureChanged() {
        return this._cultureChange$.asObservable();
    }
    /**
     * Retorna un observable que permite saber cuando se ha cambiado de cultura UI en la aplicación
     */
    get onCultureUIChanged() {
        return this._cultureUIChange$.asObservable();
    }
}
LocaleService._current = null;

/**
 * Esta Pipe sirve para obtener las traducciones literales de los Strings definidos en la aplicación, según el idioma en el que
 * esté configurado el navegador del usuario que entra en la aplicación
 *
 * @example
 * Typescript:
 * this.localeService.getLocaleString('word_indetifier_string'),
 * HTML:
 * <div>{{'word_identifier_string' | locale}}</div>
 *
 */
class LocalePipe {
    /** @ignore */
    constructor(localeService) {
        this.localeService = localeService;
    }
    /** @ignore */
    transform(value, formatString) {
        let format = this.getFormatFromString(formatString);
        return this.localeService.getLocaleString(value, format);
    }
    getFormatFromString(formatString) {
        if (formatString) {
            switch (formatString.toLowerCase()) {
                case 'lower':
                    return LocaleFormat.Lower;
                case 'upper':
                    return LocaleFormat.Upper;
                default:
                    return LocaleFormat.None;
            }
        }
        return LocaleFormat.None;
    }
}
LocalePipe.ɵfac = function LocalePipe_Factory(t) { return new (t || LocalePipe)(ɵngcc0.ɵɵdirectiveInject(LocaleService, 16)); };
LocalePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "locale", type: LocalePipe, pure: true });
/** @nocollapse */
LocalePipe.ctorParameters = () => [
    { type: LocaleService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalePipe, [{
        type: Pipe,
        args: [{ name: 'locale' }]
    }], function () { return [{ type: LocaleService }]; }, null); })();

class LocalizationModule {
}
LocalizationModule.ɵfac = function LocalizationModule_Factory(t) { return new (t || LocalizationModule)(); };
LocalizationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LocalizationModule });
LocalizationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LocalePipe
                ],
                exports: [
                    LocalePipe
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LocalizationModule, { declarations: [LocalePipe], exports: [LocalePipe] }); })();

class CommonModule {
}
CommonModule.ɵfac = function CommonModule_Factory(t) { return new (t || CommonModule)(); };
CommonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CommonModule });
CommonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            TooltipModule,
            PopupModule,
            LocalizationModule
        ], TooltipModule, PopupModule, LocalizationModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TooltipModule,
                    PopupModule,
                    LocalizationModule
                ],
                exports: [
                    TooltipModule,
                    PopupModule,
                    LocalizationModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CommonModule, { imports: [TooltipModule, PopupModule, LocalizationModule], exports: [TooltipModule, PopupModule, LocalizationModule] }); })();

/**
 * Clase ArrayUtil
 *
 * Esta clase tiene como objetivo aportar una serie de funciones de apoyo relacionadas con el objeto de tipo 'Array'.
 */
class ArrayUtil {
    /**
     * Esta función hace X
     *
     * @param data  La data a procesar
     * @returns Array<any>
     */
    static fromBase64String(data) {
        let sliceSize = 512;
        let byteCharacters = atob(data);
        let byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return byteArrays;
    }
}

/**
 * Esta clase aporta funciones para la clase string
 *
 */
// @dynamic
// fix: https://github.com/ng-packagr/ng-packagr/issues/696
class Str {
    /**
     * Esta función devuelve true si el parámetro 'data' es de tipo 'string' y false en caso contrario
     *
     * @param data El valor a comprobar si es de tipo 'string'
     * @returns boolean
     */
    static isString(data) {
        return typeof data === 'string';
    }
    /**
     * Esta función devuelve el string 'data' en formato base 64
     *
     * @param data El valor a devolver en formato base 64
     * @returns string
     */
    static toBase64String(data) {
        return btoa(data);
    }
    /**
     * Esta función devuelve el string 'value' aplicando los formatos pasados a través del parámetro 'parameters'
     *
     * @param value El valor a devolver aplicando los formatos de 'parameters'
     * @param parameters Los formatos a aplicar al string 'value'
     * @returns string
     */
    static filterFormat(value, parameters) {
        return Str.format(value, parameters);
    }
    /**
     * Esta función devuelve un string vacio
     * @returns string
     */
    static empty() {
        return '';
    }
    /**
     * Esta función determina si el string pasado como parámetro 'char' contiene únicamente elementos de tipo alfanumérico
     *
     * @param char El valor a analizar si es alfanumérico
     * @returns boolean
     */
    static isCharAlphanumeric(char) {
        return /^[a-z0-9]+$/i.test(char);
    }
    /**
     * Esta función determina si el string pasado como parámetro 'char' es printable
     *
     * @param char El valor a analizar si es printable
     * @returns boolean
     */
    static isCharPrintable(char) {
        return /^[a-z0-9!"#$%&'()*+,.\/:;<=>?@\[\] ^_`{|}~-]*$/i.test(char);
    }
    /**
     * Esta función determina si el string pasado como parámetro 'value' empieza con el substring 'start'
     *
     * @param value El valor a analizar si empieza con el substring 'start'
     * @param start Valor el cual se utiliza para ver si 'value' empieza por este substring
     * @returns boolean
     */
    static startsWith(value, start) {
        return value.indexOf(start) === 0;
    }
    /**
     * Esta función determina si el string pasado como parámetro 'value' acaba con el substring 'start'
     *
     * @param value El valor a analizar si acaba con el substring 'start'
     * @param start Valor el cual se utiliza para ver si 'value' acaba por este substring
     * @returns boolean
     */
    static endsWith(value, end) {
        return value.indexOf(end, value.length - end.length) !== -1;
    }
    /**
     * Esta función devuelve el string 'value' con su primer carácter en minuscula
     *
     * @param value El valor a devolver con el primer carácter en minúscula
     * @returns string
     */
    static toFirstCharLower(value) {
        return Str.format('{0}{1}', value[0].toLowerCase(), value.substr(1));
    }
    /**
     * Esta función hace aplica una serie de formatos al string 'value'
     *
     * @param value El valor a procesar
     * @param parameters Parametros a aplicar
     * @returns string
     */
    static format(value, ...parameters) {
        let formattedValue = value;
        if (parameters) {
            for (let i = 0; i < parameters.length; i++) {
                if (Str.isString(parameters[i])) {
                    formattedValue = Str.replaceAll(formattedValue, '{' + i + '}', parameters[i]);
                }
                else {
                    formattedValue = Str.replaceAll(formattedValue, '{' + i + '}', parameters[i] ? parameters[i].toString() : null);
                }
            }
            return formattedValue;
        }
    }
    /**
     * Esta función reemplaza todos los substrings con el nombre del parámetro 'find' dentro del string 'value'
     * por el valor del substring 'replace'
     *
     * @param value El valor a reemplazar los substring 'find' que contenga
     * @param find Substring a reemplazar por 'replace'
     * @param value Valor del substring que reemplazará los substring 'find'
     * @returns void
     */
    static replaceAll(value, find, replace) {
        let index = value.indexOf(find);
        while (index >= 0) {
            value = value.replace(find, replace);
            index = value.indexOf(find);
        }
        return value;
    }
    /**
     * Esta función hace que el string 'value' contenga a su izquierda un substring de 'padChar's con un máximo de longitud
     * indicado en el parámetro 'lenght', donde la longitud del string 'value' debe tenerse en cuenta
     *
     * @param value El valor a incluir los substring 'padChar' hasta un máximo de longitud de 'lenght'
     * @param padChar Substring a incuir
     * @param lenght Máxima longitud del string 'value' resultante
     * @returns void
     */
    static padLeft(value, padChar, length) {
        let padValue = '';
        for (let i = 0; i < length; i++) {
            padValue = padValue + padChar;
        }
        return padValue.substring(0, padValue.length - value.length) + value;
    }
    /**
     * Esta función devuelve true si el string 'value1' contiene el substring 'value2'
     *
     * @param value1 El valor a analizar si contiene el substring 'value2'
     * @param value2 Substring a mirar si está dentro del string 'value1'
     * @returns boolean
     */
    static contains(value1, value2) {
        return value1.indexOf(value2) !== -1;
    }
    /**
     * Esta función devuelve el string 'value' sin los diacriticos que pueda contener
     *
     * @param value String al cual eliminar todos los diacriticos
     * @returns string
     */
    static removeDiacritics(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        // let resultValue: string = "";
        // if (value) {
        //   let c: string;
        //   value = value.toLowerCase();
        //   for (let i = 0; i < value.length; i++) {
        //     c = value.charAt(i);
        //     if (c === "á" || c === "à" || c === "ä") {
        //       resultValue += "a";
        //     } else if (c === "é" || c === "è" || c === "ë") {
        //       resultValue += "e";
        //     } else if (c === "í" || c === "ì" || c === "ï") {
        //       resultValue += "i";
        //     } else if (c === "ó" || c === "ò" || c === "ö") {
        //       resultValue += "o";
        //     } else if (c === "ú" || c === "ù" || c === "ü") {
        //       resultValue += "u";
        //     } else {
        //       resultValue += c;
        //     }
        //   }
        // }
        // return resultValue;
    }
    /**
     * Esta función devuelve el string 'value' con el primer char en mayuscula
     *
     * @param value String al cual poner el primer char en mayuscula
     * @returns string
     */
    static capitalize(value) {
        if (!value) {
            return null;
        }
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}
Str.Base64KeyString = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

/**
 * Clase BlobUtil
 *
 * Esta clase tiene como objetivo hacer X
 */
class BlobUtil {
    /** @ignore */
    constructor() { }
    /**
     * Esta función permite abrir un archivo a través de la data que se pasa por parámetro. También se debe definir el nombre
     * y la extensión de dicho archivo
     *
     * @param data La data del archivo
     * @param fileName Nombre del archivo
     * @param extension Extensión del archivo
     * @returns void
     */
    static openFile(data, fileName, extension) {
        let blob = new Blob(data, { type: BlobUtil.getContentType(extension) });
        //FIX:  There is a bug that prevents Safari 12 or higher from working like the other browsers do.
        //      When the bug is fix, this function needs to be deleted.
        //LINK: https://bugs.webkit.org/show_bug.cgi?id=197441
        if (this.isSafari12orHigher()) {
            window.open(URL.createObjectURL(blob), '_self');
        }
        else if (window.navigator.msSaveOrOpenBlob) {
            let name = Str.format('{0}{1}', fileName, extension);
            window.navigator.msSaveOrOpenBlob(blob, name);
        }
        else {
            let url = URL.createObjectURL(blob);
            this.openObjectURL(url, fileName, extension);
        }
    }
    /**
     * En el caso de que ya se tenga la URL del objeto, esta función permite abrir un archivo a través de la URL de dicho archivo.
     * También se debe definir el nombre y la extensión de dicho archivo
     *
     * @param objectURL La URL del objeto
     * @param fileName Nombre del archivo
     * @param extension Extensión del archivo
     */
    static openObjectURL(objectURL, fileName, extension) {
        let name = Str.format('{0}{1}', fileName, extension);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = objectURL;
        a.download = name;
        a.click();
        a.remove();
        URL.revokeObjectURL(objectURL);
    }
    /**
     * Esta función obtiene el tipo de extensión que tiene el archivo para poder montar el objeto de tipo Blob
     *
     * @param extension Extensión del archivo
     */
    static getContentType(extension) {
        switch (extension.replace('.', '')) {
            case 'xls':
                return 'application/vnd.ms-excel';
            case 'xlsx':
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            case 'doc':
                return 'application/msword';
            case 'docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case 'ppt':
                return 'application/vnd.ms-powerpoint';
            case 'pptx':
                return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
            case 'txt':
                return 'text/plain';
            case 'pdf':
                return 'application/pdf';
            case 'zip':
                return 'application/zip';
            case 'rar':
                return 'application/x-rar-compressed';
            case 'rtf':
                return 'application/rtf';
            case 'xml':
                return 'application/xml';
            default:
                return 'application/octet-stream';
        }
    }
    static isSafari12orHigher() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            const version = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || '0', 10)];
            return version[0] >= 12;
        }
    }
}

/**
 * Clase Bool
 *
 * Esta clase tiene como objetivo aportar una serie de funciones de apoyo relacionadas con el objeto de tipo 'Boolean', como por
 * ejemplo comprobar que el objeto realmente es de tipo 'Boolean'.
 */
// @dynamic
// fix: https://github.com/ng-packagr/ng-packagr/issues/696
class Bool {
    /**
     * Esta función devuelve true si el parámetro 'data' es de tipo 'Boolean' y false en caso contrario
     *
     * @param data El valor a comprobar si es de tipo 'Boolean'
     * @returns boolean
     */
    static isBoolean(data) {
        return typeof data === 'boolean';
    }
    /**
     * Esta función tiene como objetivo valorar el parámetro 'value', en formato de string, y determinar
     * si su contenido tiene como significado true o false
     *
     * @param value El valor a procesar para determinar si es true o false
     * @returns boolean
     */
    static parse(value) {
        let booleanValue = false;
        if (!Bool.isBoolean(value)) {
            if (value) {
                let upperCaseValue = value.toUpperCase();
                let initialUpperCaseValue = upperCaseValue.substr(0, 1);
                booleanValue =
                    value === '1' ||
                        upperCaseValue === 'TRUE' ||
                        upperCaseValue === 'ON' ||
                        upperCaseValue === 'OUI' ||
                        upperCaseValue === 'O' ||
                        initialUpperCaseValue === 'S' ||
                        initialUpperCaseValue === 'Y' ||
                        initialUpperCaseValue === 'J';
            }
            return booleanValue;
        }
        else {
            return value;
        }
    }
    /**
     * Esta función tiene como objetivo devolver un string según el valor del 'Boolean' que se le pase como parametro, siendo "Yes"
     * en caso de true y "No" en caso de false
     *
     * @param value El valor 'Boolean' a valorar
     * @returns string
     */
    static toString(value) {
        return value ? LocaleService.current.getLocaleString('yes') : LocaleService.current.getLocaleString('no');
    }
}

/**
 * Clase DateTime
 *
 * Esta clase tiene como objetivo aportar una serie de funciones de apoyo relacionadas con el objeto de tipo 'Date', como por
 * ejemplo comprobar que el objeto realmente es de tipo 'Date'.
 */
class DateTime {
    /**
     * Esta función devuelve true si el parámetro 'data' es de tipo 'Date' y false en caso contrario
     *
     * @param data El valor a comprobar si es de tipo 'Date'
     */
    static isDate(data) {
        return data instanceof Date;
    }
    /**
    * Esta función devuelve true si el parámetro 'data' es de tipo 'Date' y tiene un formato correcto
    *
    * @param data El valor a comprobar si es de tipo 'Date'
    */
    static isValid(date) {
        return DateTime.isDate(date) && !isNaN(date);
    }
    /**
     * Esta función añade extensiones alos formatos de las fechas
     */
    static addExtensionMethods() {
        Date.prototype.toFormatString = function (format) {
            if (!format) {
                format = DateTimeFormat.Date;
            }
            if (Str.isString(format)) {
                format = DateTimeFormat[format];
            }
            return DateTime.toString(this, format);
        };
    }
    /**
     * Esta función devuelve el parametro 'value' de tipo 'Date' como string con el formato que se le pase por el parámetro 'format'
     *
     * @param value El valor a procesar para devolverlo en forma de string
     * @param formate El formato a aplicar al parámetro 'value' de tipo 'Date'
     */
    static filter(value, format) {
        return DateTime.toString(value, DateTimeFormat[format]);
    }
    /**
     * Esta función devuelve un objeto de tipo 'Date' con el valor que es considerado máximo en este entorno, que es Date(9999, 12, 31)
     */
    static max() {
        return new Date(9999, 12, 31);
    }
    /**
     * Esta función devuelve un objeto de tipo 'Date' con la fecha del parámetro de entra, y el tiempo asignado a 0.
     */
    static convertToDate(dateTime, twoDigitYearMax) {
        let result = null;
        if (DateTime.isValid(dateTime)) {
            twoDigitYearMax = twoDigitYearMax ? twoDigitYearMax : 40;
            let year = dateTime.getFullYear();
            if (year < 100) {
                year = (year <= twoDigitYearMax) ? year + 2000 : year + 1900;
            }
            result = new Date(Date.UTC(year, dateTime.getMonth(), dateTime.getDate()));
        }
        return result;
    }
    /**
     * Esta función devuelve el mes indicado en el parámetro 'month' en formato de string, con la cultura indicada en el parámetro 'culture'
     *
     * @param month El valor a procesar para devolverlo en forma de string
     * @param culture La cultura a aplicar al parámetro 'month' de tipo number
     */
    static getMonthName(month, culture) {
        let lang = culture;
        if (lang.indexOf("-") > 0 && month >= 0 && month <= 12) {
            lang = lang.split("-")[0];
            return DateTime.months[lang].names[month - 1];
        }
        return null;
    }
    /**
     * Esta función devuelve el mes indicado en el parámetro 'month' en formato de string y abreviados,
     * con la cultura indicada en el parámetro 'culture'
     *
     * @param month El valor a procesar para devolverlo en forma de string abreviado
     * @param culture La cultura a aplicar al parámetro 'month' de tipo number
     * @returns string
     */
    static getMonthShortName(month, culture) {
        let lang = culture;
        if (lang.indexOf("-") > 0 && month >= 1 && month <= 12) {
            lang = lang.split("-")[0];
            return DateTime.months[lang].shortNames[month - 1];
        }
        return null;
    }
    /**
     * Esta función devuelve si el parámetro 'value' es null, con un parámetro opcional adicional 'format' de tipo DateTimeFormat
     *
     * @param value El valor a determinar si es null
     * @param format El formato opcional a aplicar al parámetro 'value'
     * @returns boolean
     */
    static isNull(value, format) {
        if (DateTime.isDate(value)) {
            return value ? false : true;
        }
        else {
            return !value || DateTime.parse(value, format) == null;
        }
    }
    /**
     * Esta función cambia el parametro local 'locale' de la clase DateTime,
     * el cual definirá el idioma y pais de los futuros Date que se vayan a utilitzar
     *
     * @param locale El locale a cambiar de la clase DateTime
     * @returns void
     */
    static setLocale(locale) {
        DateTime._locale = locale;
    }
    /**
     * Esta función obtiene el valor del parámetro local de la clase DateTime llamado 'locale'
     *
     * @returns string
     */
    static getLocale() {
        return DateTime._locale;
    }
    /**
     * Esta función devuelve el formato de string 'DD/MM/YYYY' a partir del parámetro 'value' de tipo Date
     *
     * @param value La Date a procesar para obtenerla en formato de string 'DD/MM/YYYY'
     * @returns string
     */
    static toDateString(value) {
        return DateTime.toString(value, DateTimeFormat.Date);
    }
    /**
     * Esta función devuelve el formato de string 'HH:mm' a partir del parámetro 'value' de tipo Date
     *
     * @param value La Date a procesar para obtenerla en formato de string 'HH:mm'
     * @returns string
     */
    static toShortTimeString(value) {
        return DateTime.toString(value, DateTimeFormat.ShortTime);
    }
    /**
     * Esta función devuelve un string a partir del parámetro 'value' de tipo Date en el formato indicado en el parámetro 'format' de tipo DateTimeFormat
     *
     * @param value La Date a procesar para obtenerla en formato 'format'
     * @param format El formato a aplicar a la Date 'value'
     * @returns string
     */
    static toString(value, format) {
        let stringFormat = DateTime.getStringFormat(format);
        if (value) {
            let dt2Format = DateTime$1.fromJSDate(value, {
                locale: DateTime._locale
            });
            if (dt2Format.isValid) {
                return dt2Format.toFormat(stringFormat);
            }
            return value.toString();
        }
        return null;
    }
    /**
     * Esta función devuelve la Date a través del string 'value' que representa una Date en el DateTimeFormat 'format'
     *
     * @param value La Date a procesar con el formato 'format'
     * @param format El formato que tiene el parámetro 'value'
     * @returns Date
     */
    static parse(value, format) {
        let stringFormat = DateTime.getStringFormat(format);
        if (value) {
            let dt2Parse = DateTime$1.fromFormat(value, stringFormat, {
                locale: DateTime._locale
            });
            if (dt2Parse.isValid) {
                return dt2Parse.toJSDate();
            }
            return new Date(value);
        }
        return null;
    }
    /**
     * Esta función devuelve la Date que está en formato UTC en formato de tiempo local
     *
     * @param value La Date a procesar
     * @returns Date
     */
    static convertUTCDateToLocalDate(date) {
        let newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        let offset = date.getTimezoneOffset() / 60;
        let hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    }
    /**
     * @ignore {Date} value La Date a procesar
     */
    static getStringFormat(format) {
        switch (format) {
            case DateTimeFormat.Date:
                switch (DateTime.getLocale()) {
                    default:
                        return "dd/LL/yyyy";
                }
            case DateTimeFormat.DateTime:
                switch (DateTime.getLocale()) {
                    default:
                        return "dd/LL/yyy HH:mm:ss";
                }
            case DateTimeFormat.DateShortTime:
                switch (DateTime.getLocale()) {
                    default:
                        return "dd/LL/yyyy HH:mm";
                }
            case DateTimeFormat.ShortTime:
                return "HH:mm";
            case DateTimeFormat.Time:
                return "HH:mm:ss";
            case DateTimeFormat.DateMedium:
                return "d LLL yy";
            case DateTimeFormat.None:
                return null;
            case DateTimeFormat.FullDateTime:
                return "yyyy-LL-dd HH:mm:ss.SSS";
            case DateTimeFormat.FlatDate:
                return "yyyyLLdd";
            case DateTimeFormat.MonthYear:
                return "LLLL yyyy";
            case DateTimeFormat.DateTimeAndWeekday:
                return "d LLLL yyyy HH:mm:ss";
            case DateTimeFormat.DateWithMonth:
                return "d LLL yyyy";
            case DateTimeFormat.DateTimeWithMonth:
                return "d LLL yyyy HH:mm:ss";
            case DateTimeFormat.MonthDay:
                return "LLLL d";
            default:
                return "dd/LL/yyyy";
        }
    }
    /**
     * Esta función suma a la Date 'date' la duración indicada en el parámetro 'duration',
     * y indicando en el parámetro 'unitOfTime' de qué tipo es el parámetro 'duration' (hours, days, weeks, months, years)
     *
     * @param value La Date a procesar
     * @param duration La cantidad a sumar
     * @param unitOfTime El tipo de unidad de tiempo a sumar
     * @returns void
     */
    static add(date, duration, unitOfTime) {
        return DateTime$1
            .fromJSDate(date, { locale: DateTime._locale })
            .plus(DateTime.GetDuration(duration, unitOfTime))
            .toJSDate();
    }
    /**
     * Esta función resta a la Date 'date' la duración indicada en el parámetro 'duration',
     * y indicando en el parámetro 'unitOfTime' de qué tipo es el parámetro 'duration' (hours, days, weeks, months, years)
     *
     * @param value La Date a procesar
     * @param duration La cantidad a restar
     * @param unitOfTime El tipo de unidad de tiempo a restar
     * @returns void
     */
    static substract(date, duration, unitOfTime) {
        return DateTime$1
            .fromJSDate(date, { locale: DateTime._locale })
            .minus(DateTime.GetDuration(duration, unitOfTime))
            .toJSDate();
    }
    /**
     * Esta función indica si las Date indicadas en los parámetros son iguales
     *
     * @param date1 La primera data a comparar
     * @param date2 La segonda data a comparar
     * @returns void
     */
    static areEqual(date1, date2) {
        return ((date1 && date2 && date1.getTime() === date2.getTime()) ||
            (!date1 && !date2));
    }
    /**
     * Esta función devuelve la fecha pasada por parámetro con las horas, minutos, segundos y milisegundos seteados a cero.
     * @param date Fecha a setear horas, minutos, segundos y milisegundos a cero
     */
    static withoutTime(date) {
        const dateWithoutTime = new Date(date);
        dateWithoutTime.setHours(0, 0, 0, 0);
        return dateWithoutTime;
    }
    static timeAgoFormat(date) {
        return DateTime$1.local(date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes()).minus({ minute: 1 }).toRelative();
    }
    /**
     * Esta función indica la diferencia en tiempo (indicando la magnitud en el parámetro 'unitOfTime' de tipo UnitOfTime)
     * de las fechas startDate y endDate de tipo Date
     *
     * @param startDate La primera data a comparar
     * @param endDate La segonda data a comparar
     * @param unitOfTime El tipo de unidad de tiempo a comparar
     * @returns void
     */
    static difference(startDate, endDate, unitOfTime) {
        let startLxnDate = DateTime$1.fromJSDate(startDate, {
            locale: DateTime._locale
        });
        let endLxnDate = DateTime$1.fromJSDate(endDate, {
            locale: DateTime._locale
        });
        return endLxnDate
            .diff(startLxnDate)
            .as(DateTime.GetUnitOfTimeString(unitOfTime));
    }
    /**
     * @ignore {Date} value La Date a procesar
     */
    static GetUnitOfTimeString(unitOfTime) {
        let unitOfTimeString = "days";
        switch (unitOfTime) {
            case UnitOfTime.Hours:
                unitOfTimeString = "hours";
                break;
            case UnitOfTime.Days:
                unitOfTimeString = "days";
                break;
            case UnitOfTime.Weeks:
                unitOfTimeString = "weeks";
                break;
            case UnitOfTime.Months:
                unitOfTimeString = "months";
                break;
            case UnitOfTime.Years:
                unitOfTimeString = "years";
                break;
        }
        return unitOfTimeString;
    }
    /**
     * @ignore {Date} value La Date a procesar
     */
    static GetDuration(duration, unitOfTime) {
        let result;
        switch (unitOfTime) {
            case UnitOfTime.Hours:
                result = Duration.fromObject({ hours: duration });
                break;
            case UnitOfTime.Days:
                result = Duration.fromObject({ days: duration });
                break;
            case UnitOfTime.Weeks:
                result = Duration.fromObject({ weeks: duration });
                break;
            case UnitOfTime.Months:
                result = Duration.fromObject({ months: duration });
                break;
            case UnitOfTime.Years:
                result = Duration.fromObject({ years: duration });
                break;
        }
        return result;
    }
}
DateTime._locale = 'es';
/**
 * @ignore
 */
DateTime.months = {
    en: {
        names: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]
    },
    es: {
        names: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ],
        shortNames: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]
    },
    ca: {
        names: [
            "Gener",
            "Febrer",
            "Març",
            "Abril",
            "Maig",
            "Juny",
            "Juliol",
            "Agost",
            "Setembre",
            "Octubre",
            "Novembre",
            "Dessembre"
        ],
        shortNames: [
            "Gen",
            "Feb",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Oct",
            "Nov",
            "Des"
        ]
    }
};
var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat[DateTimeFormat["None"] = 0] = "None";
    DateTimeFormat[DateTimeFormat["Date"] = 1] = "Date";
    DateTimeFormat[DateTimeFormat["DateTime"] = 2] = "DateTime";
    DateTimeFormat[DateTimeFormat["DateShortTime"] = 3] = "DateShortTime";
    DateTimeFormat[DateTimeFormat["ShortTime"] = 4] = "ShortTime";
    DateTimeFormat[DateTimeFormat["Time"] = 5] = "Time";
    DateTimeFormat[DateTimeFormat["DateMedium"] = 6] = "DateMedium";
    DateTimeFormat[DateTimeFormat["FullDateTime"] = 7] = "FullDateTime";
    DateTimeFormat[DateTimeFormat["FlatDate"] = 8] = "FlatDate";
    DateTimeFormat[DateTimeFormat["MonthYear"] = 9] = "MonthYear";
    DateTimeFormat[DateTimeFormat["DateTimeAndWeekday"] = 10] = "DateTimeAndWeekday";
    DateTimeFormat[DateTimeFormat["DateWithMonth"] = 11] = "DateWithMonth";
    DateTimeFormat[DateTimeFormat["DateTimeWithMonth"] = 12] = "DateTimeWithMonth";
    DateTimeFormat[DateTimeFormat["MonthDay"] = 13] = "MonthDay";
})(DateTimeFormat || (DateTimeFormat = {}));
var UnitOfTime;
(function (UnitOfTime) {
    UnitOfTime[UnitOfTime["Hours"] = 0] = "Hours";
    UnitOfTime[UnitOfTime["Days"] = 1] = "Days";
    UnitOfTime[UnitOfTime["Weeks"] = 2] = "Weeks";
    UnitOfTime[UnitOfTime["Months"] = 3] = "Months";
    UnitOfTime[UnitOfTime["Years"] = 4] = "Years";
})(UnitOfTime || (UnitOfTime = {}));
DateTime.addExtensionMethods();

/**
 * Clase Guid
 *
 * Esta clase tiene como objetivo X
 */
class Guid {
    /**
     * Esta función X
     *
     * @returns string
     */
    static newGuid() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }
    /**
     * Esta función X
     *
     * @returns string
     */
    static s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
}

/**
 * Esta clase aporta funciones relacionadas con el type 'number'
 *
 */
// @dynamic
// fix: https://github.com/ng-packagr/ng-packagr/issues/696
class Num {
    /**
     * Esta función devuelve true si el parámetro 'data' es de tipo 'number' y false en caso contrario
     *
     * @param data El valor a comprobar si es de tipo 'number'
     * @returns boolean
     */
    static isNumber(data) {
        return typeof data === "number";
    }
    /**
     * Esta función devuelve true si el parámetro 'value' de tipo any es null
     *
     * @param value El valor a determinar si es null
     * @returns boolean
     */
    static isNull(value) {
        if (Num.isNumber(value)) {
            return value || value === 0 ? false : true;
        }
        else {
            return (!value ||
                isNaN(Number(value)));
        }
    }
    /**
     * Esta función devuelve true si el paràmetre 'char' de tipus string, al convertirlo en tipo number, es realmente de tipo number
     *
     * @param char El valor a determinar si es al parsearlo es de tipo number
     * @returns boolean
     */
    static isCharNumeric(char) {
        return !!/\d/.test(char);
    }
    /**
     * Esta función analiza el parámetro 'value' de tipo string y lo devuelve en
     * formato number aplicando la cultura que se especifique en el parámetro 'culture'
     *
     * @param value El valor a analizar para devolverlo en formato number
     * @param culture La cultura a aplicar al number a devolver
     * @returns number
     */
    static parseString(value, culture) {
        if (value) {
            value = value.split(Num.thousandSeparator(culture)).join("");
            value = value.replace(Num.decimalSeparator(culture), ".");
            return Num.parse(value);
        }
        else {
            return null;
        }
    }
    /**
     * Esta función analiza el parámetro 'value' de tipo any y lo devuelve en formato number
     *
     * @param value El valor a analizar para devolverlo en formato number
     * @returns number
     */
    static parse(value) {
        return Number(value);
    }
    /**
     * Esta función devuelve el separador de millares, dependiendo de la culture que se le pase al parámetro 'culture'
     *
     * @param culture La cultura a aplicar al separador de millares
     * @returns string
     */
    static thousandSeparator(culture) {
        let value = 10000;
        let result = value.toLocaleString(culture);
        return result.substr(2, 1);
    }
    /**
     * Esta función devuelve el separador de decimales, dependiendo de la culture que se le pase al parámetro 'culture'
     *
     * @param culture La cultura a aplicar al separador de decimales
     * @returns string
     */
    static decimalSeparator(culture) {
        let value = 1.1;
        let result = value.toLocaleString(culture);
        return result.substr(1, 1);
    }
    /**
     * Esta función analiza el parámetro 'value' de tipo any y lo devuelve en formato string, aplicando la cultura 'culture'
     *
     * @param value El valor a analizar para devolverlo en formato string
     * @param culture La cultura a aplicar al resultado string
     * @returns string
     */
    static toString(value, culture = null, numOfDecimals = null) {
        if (!culture) {
            culture = LocaleService.current.currentCulture;
        }
        return Num.format(value, Num.decimalSeparator(culture), Num.thousandSeparator(culture), numOfDecimals);
    }
    static format(value, decimalSeparator, thousandSeparator, numOfDecimalsArg = null) {
        if (!value && value !== 0) {
            return Str.empty();
        }
        // need a string for operations
        let isNegative = false;
        let result = value.toString();
        if (result && Str.startsWith(result, "-")) {
            isNegative = true;
            result = result.substr(1);
        }
        // separate the whole number and the fraction if possible
        let a;
        if (Num.isNumber(value)) {
            a = result.split(".");
        }
        else {
            a = result.split(decimalSeparator);
        }
        let x = a[0]; // decimal
        let y = a[1]; // fraction
        let z = Str.empty();
        if (x) {
            // reverse the digits. regexp works from left to right.
            for (let i = x.length - 1; i >= 0; i--) {
                z += x.charAt(i);
            }
            // add seperators. but undo the trailing one, if there
            z = z.replace(/(\d{3})/g, "$1" + thousandSeparator);
            if (z.slice(-thousandSeparator.length) === thousandSeparator) {
                z = z.slice(0, -thousandSeparator.length);
            }
            x = "";
            // reverse again to get back the number
            for (let i = z.length - 1; i >= 0; i--) {
                x += z.charAt(i);
            }
            // add the fraction back in, if it was there
            if ((y && y.length > 0) || numOfDecimalsArg !== 0) {
                let decimalsLength = y ? y.length : 0;
                let numDecimals = numOfDecimalsArg != null ? numOfDecimalsArg : decimalsLength;
                let decimalPart = y ? y.substr(0, numDecimals) : "";
                if (numDecimals > 0) {
                    x += decimalSeparator + decimalPart.padEnd(numDecimals, '0');
                }
            }
        }
        if (isNegative) {
            return Str.format("-{0}", x);
        }
        else {
            return x;
        }
    }
}

/**
 * Esta clase sirve para todo lo relacionado con las propiedades de los objetos, como asignar valor a éstos,
 * obtener sus propiedades, inicializarlos a null, etc.
 *
 */
class Reflection {
    /**
     * Esta función asigna el valor 'value' de tipo any a la propiedad 'property' del objeto 'item'
     *
     * @param item El objeto al cual se le asignará el valor a su propiedad
     * @param property La propiedad la cual cambiarle el valor
     * @param value El nuevo valor que se le asignará a la propiedad
     * @returns void
     */
    static setPropertyValue(item, property, value) {
        if (item) {
            let properties = property.split('.');
            if (properties.length === 1) {
                item[properties[0]] = value;
                return item;
            }
            else {
                let propertyValue = item[properties[0]];
                if (propertyValue) {
                    propertyValue = {};
                    item[properties[0]] = propertyValue;
                }
                Reflection.setPropertyValue(propertyValue, properties.slice(1).join('.'), value);
            }
        }
        else {
            return null;
        }
    }
    /**
     * Esta función obtiene el valor de la propiedad indicada en 'property' del objeto 'value'
     *
     * @param value El objeto con la propiedad 'property'
     * @param property La propiedad la cual se quiere el valor
     * @returns any
     */
    static getPropertyValue(value, property) {
        if (value) {
            let properties = property.split('.');
            if (properties.length === 1) {
                return value[properties[0]];
            }
            else {
                return Reflection.getPropertyValue(value[properties[0]], properties.slice(1).join('.'));
            }
        }
        else {
            return null;
        }
    }
    /**
     * Esta función obtiene todas las propiedades del objeto 'value' de tipo any en forma de array de string
     *
     * @param value El objeto del cual se obtendrán las propiedades
     * @returns Array<string>
     */
    static getProperties(value) {
        let properties = Object.getOwnPropertyNames(value);
        properties = properties.filter((property) => property[0] !== '_');
        return properties;
    }
    /**
     * Esta función hace que el item 'target' tenga las mismas propiedades y valores que el item 'source',
     * indicando exactamente cuales, de manera opcional, en la propiedad 'properties'
     *
     * @param source El objeto donde se obtienen las propiedades y valores
     * @param target El objeto que recibirá las propiedades y valores del objeto source
     * @param properties? Las propiedades a pasar del objeto 'source' al objeto 'target'
     * @returns void
     */
    static sync(source, target, properties) {
        if (!properties || properties.length === 0) {
            properties = Reflection.getProperties(source);
        }
        for (let i = 0; i < properties.length; i++) {
            let property = properties[i];
            if (property.indexOf('.') === 0) {
                target[property] = source[property];
            }
            else {
                let propertyNames = property.split('.');
                let subSource = source;
                let subTarget = target;
                for (let j = 0; j < propertyNames.length - 1; j++) {
                    if (!subTarget.hasOwnProperty(propertyNames[j])) {
                        subTarget[propertyNames[j]] = {};
                    }
                    subSource = subSource[propertyNames[j]];
                    subTarget = subTarget[propertyNames[j]];
                }
                if (subSource && subSource.hasOwnProperty(propertyNames[propertyNames.length - 1])) {
                    subTarget[propertyNames[propertyNames.length - 1]] = subSource[propertyNames[propertyNames.length - 1]];
                }
            }
        }
    }
    /**
     * Esta función devuelve true si la propiedad 'property' existeix com a propietat del objecte 'value'
     *
     * @param value El objeto donde se mirará si la propiedad 'property' existe
     * @param property Nombre de la propiedad a mirar al objeto 'value'
     * @returns boolean
     */
    static existsProperty(value, property) {
        return value.hasOwnProperty(property);
    }
    /**
     * Esta función sirve para inicializar el objeto 'item' a través de la instanciación a null de una de sus propiedades.
     *
     * @param item Objeto al cual inicializar la propiedad
     * @param property Nombre de la propiedad a mirar al objeto 'value'
     * @returns void
     */
    static createFullPropertyPath(item, property) {
        if (property.indexOf('.') > 0) {
            let propertyNames = property.split('.');
            let source = item;
            for (let i = 0; i < propertyNames.length - 1; i++) {
                if (!Reflection.existsProperty(source, propertyNames[i])) {
                    source[propertyNames[i]] = {};
                }
                source = source[propertyNames[i]];
            }
            if (!source.hasOwnProperty(propertyNames[propertyNames.length - 1])) {
                source[propertyNames[propertyNames.length - 1]] = null;
            }
        }
    }
    /**
     * Esta función devuelve un array de string de las propiedades que sean diferentes entre los objetos 'newValue' y 'oldValue'
     *
     * @param newValue Objeto al cual comparar con el objeto 'oldValue'
     * @param oldValue Objeto al cual comparar con el objeto 'newValue'
     * @returns Array<string>
     */
    static getDifferentPropertiesValue(newValue, oldValue) {
        let properties = new Array();
        if (newValue) {
            properties = Reflection.getProperties(newValue);
        }
        properties = properties.filter((property) => {
            let newPropertyValue = newValue[property];
            let oldPropertyValue = oldValue[property];
            return (newPropertyValue !== oldPropertyValue);
        });
        return properties;
    }
    /**
     * Esta función devuelve true si el objeto 'value1' y el objeto 'value2' tienen las mismas propiedades
     *
     * @param value1 Objeto al cual comparar con el objeto 'value2'
     * @param value2 Objeto al cual comparar con el objeto 'value1'
     * @returns boolean
     */
    static areEqual(value1, value2) {
        let properties = Reflection.getDifferentPropertiesValue(value1, value2);
        return !properties || properties.length === 0;
    }
    /**
     * Esta función elimina la propiedad 'propertyName' del objeto 'value'
     *
     * @param value Objeto al cual eliminar la propiedad 'propertyName'
     * @param propertyName Propiedad a borrar del objeto 'value'
     * @returns boolean
     */
    static deleteProperty(value, propertyName) {
        delete value[propertyName];
    }
    /**
   * Esta función clona el valor pasado
   *
   * @param value Objeto al cual se clonará.
   * @returns T
   */
    static clone(value) {
        return JSON.parse(JSON.stringify(value));
    }
}

/**
 * Esta clase aporta una serie de funciones para determinar si los parámetros que se les pasa son de tipo Object o Function
 */
class Type {
    /**
     * Esta función devuelve true si el parámetro 'value' es de tipo object
     * @param value Valor a determinar si es parámetro value es de tipo object
     * @returns
     */
    static isObject(value) {
        return typeof value === 'object';
    }
    /**
     * Esta función devuelve true si el parámetro 'value' es de tipo function
     * @param value Valor a determinar si es parámetro value es de tipo function
     * @returns
     */
    static isFunction(value) {
        return typeof value === 'function';
    }
    /**
    * Esta función devuelve el valor del parametro que le pases, ya sea una función o el propio valor. Evita que el desarrollador tenga que comprovar si es función o no, para obtener el valor.
    * @param value Valor a devolver o función a ejecutar para obtener el valor.
    * @returns valor pasado como parametro o valor obtenido de llamar a la función.
    */
    static getValue(value) {
        let result = null;
        if (Type.isFunction(value)) {
            result = value();
        }
        else {
            result = value;
        }
        return result;
    }
}

/** Clase que se utiliza principalmente para observar cambios en objetos */
class ObjectWatcher {
    constructor() {
        this._proxyChanges = new Subject();
        this._proxyObjs = new Map();
    }
    /**
     * Método principal que se utiliza para hacer un seguimiento del objeto que se pase por parámetro. Este método retorna
     * el mismo objeto en forma de proxy, para poder detectar los cambios que se produzcan en éste
     *
     * @param obj Objeto en el que se quiere observar los cambios que se produzcan
     */
    watch(obj) {
        let handler = {
            get: (target, property, receiver) => {
                if (property === '__target') {
                    return target;
                }
                if (property === '__isProxy') {
                    return true;
                }
                if (target instanceof Date && target[property]) {
                    return target[property].bind(target);
                }
                if (typeof target[property] === 'object' && target[property] !== null && target.hasOwnProperty(property)) {
                    let existingProxy = this._proxyObjs.get(target[property]);
                    if (existingProxy && existingProxy.__target === target[property]) {
                        return existingProxy;
                    }
                    let receiverProxy = null;
                    this._proxyObjs.forEach((value, key) => {
                        if (receiver === value) {
                            receiverProxy = receiver;
                        }
                    });
                    if (receiverProxy) {
                        let proxy = this.watch(target[property]);
                        this._proxyObjs.set(target[property], proxy);
                        return proxy;
                    }
                }
                return target[property];
            },
            set: (target, property, value) => {
                if (target[property] !== value) {
                    Reflect.set(target, property, value);
                    this.onValidateChange(target, property);
                }
                return true;
            }
        };
        let proxy = new Proxy(obj, handler);
        this._proxyObjs.set(obj, proxy);
        return proxy;
    }
    /**
     * Método que sirve para dejar de observar un objeto. Se debe pasar el objeto en forma de proxy para dejar de hacer un seguimiento
     * de éste
     *
     * @param proxyObj
     */
    unwatch(proxyObj) {
        for (let property in proxyObj) {
            if (proxyObj.hasOwnProperty(property) && typeof proxyObj[property] === 'object') {
                this.unwatch(proxyObj[property]);
            }
        }
        this._proxyObjs.forEach((value, key) => {
            if (proxyObj === value) {
                this._proxyObjs.delete(key);
            }
        });
    }
    onValidateChange(obj, property) {
        this._proxyChanges.next({
            object: obj,
            property: property,
            proxyObject: this._proxyObjs.get(obj)
        });
    }
    /**
     * Observable que permite detectar los cambios que se produzcan en los objetos afectados por el método 'watch'
     */
    get onChange() {
        return this._proxyChanges.asObservable();
    }
}

/** Configuración predeterminada del tooltip */
class NgwkTooltipConfig {
    constructor() {
        /** Permite definir la configuración de autoclose del tooltip. Por defecto está a true, haciendo que se cierre al hacer mouseleave
           * en el elemento HTML que tiene el tooltip. La configuración 'inside' permite cerrar el tooltip cuando se hace click dentro
           * de éste y la de 'outside' cuando se hace click fuera de éste. */
        this.autoClose = true;
        /** Permite definir la posición del del tooltip. Por defecto está en 'top' */
        this.placement = 'top';
        /** Triggers del tooltip. Por defecto está el de hover */
        this.triggers = 'hover';
        /** Permite habilitar o deshabilitar el tooltip. Por defecto está habilitado */
        this.disableTooltip = false;
    }
}
NgwkTooltipConfig.ɵfac = function NgwkTooltipConfig_Factory(t) { return new (t || NgwkTooltipConfig)(); };
NgwkTooltipConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgwkTooltipConfig, factory: NgwkTooltipConfig.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgwkTooltipConfig, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Servicio para internacionalizar (fechas, numeros, etc) los controles de Kendo.
 */
class KendoIntlService extends CldrIntlService {
    /** @ignore */
    constructor(localeId, _localeService) {
        super(localeId);
        this._localeService = _localeService;
        this._localeService.onCultureChanged.subscribe((culture) => this.onCultureChanged(culture));
    }
    onCultureChanged(culture) {
        this.localeId = culture;
    }
}
KendoIntlService.ɵfac = function KendoIntlService_Factory(t) { return new (t || KendoIntlService)(ɵngcc0.ɵɵinject(LOCALE_ID), ɵngcc0.ɵɵinject(LocaleService)); };
KendoIntlService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: KendoIntlService, factory: KendoIntlService.ɵfac });
/** @nocollapse */
KendoIntlService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] },
    { type: LocaleService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KendoIntlService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }, { type: LocaleService }]; }, null); })();

/**
 * Servicio para Localizar (traducción de los literales) los controles de Kendo.
 * Para ver todas las 'labels' que se deben traducir, podeis consultarlo en https://github.com/telerik/kendo-angular-messages/tree/develop/messages
 */
class KendoMessageService extends MessageService {
    /** @ignore */
    constructor(_localeService) {
        super();
        this._localeService = _localeService;
    }
    getCultureKey(culture) {
        return Str.contains(culture, '-') ? culture.split('-')[0] : culture;
    }
    get messages() {
        const lang = LANGUAGE_RESOURCES_DATA[this.getCultureKey(this._localeService.currentCultureUI)];
        if (lang) {
            return lang.messages;
        }
    }
    /**
     * Obtener la traducción de la key/label facilitada.
     * @param key label a traducir
     */
    get(key) {
        return this.messages[key];
    }
}
KendoMessageService.ɵfac = function KendoMessageService_Factory(t) { return new (t || KendoMessageService)(ɵngcc0.ɵɵinject(LocaleService)); };
KendoMessageService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: KendoMessageService, factory: KendoMessageService.ɵfac });
/** @nocollapse */
KendoMessageService.ctorParameters = () => [
    { type: LocaleService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KendoMessageService, [{
        type: Injectable
    }], function () { return [{ type: LocaleService }]; }, null); })();
/** @ignore */
class LanguagesResource {
}
/** @ignore */
class LanguageMessages {
}
/** @ignore */
class Messages {
}
/** @ignore */
const LANGUAGE_RESOURCES_DATA = {
    'ca': {
        messages: {
            'kendo.datepicker.today': 'Avui',
            'kendo.datepicker.toggle': 'Veure calendari',
            'kendo.numerictextbox.increment': 'Augmentar valor',
            'kendo.numerictextbox.decrement': 'Disminuir valor'
        }
    },
    'en': {
        messages: {
            'kendo.datepicker.today': 'Today',
            'kendo.datepicker.toggle': 'Toggle calendar',
            'kendo.numerictextbox.increment': 'Increase value',
            'kendo.numerictextbox.decrement': 'Decrease value'
        }
    },
    'es': {
        messages: {
            'kendo.datepicker.today': 'Hoy',
            'kendo.datepicker.toggle': 'Ver calendario',
            'kendo.numerictextbox.increment': 'Aumentar valor',
            'kendo.numerictextbox.decrement': 'Disminuir valor'
        }
    }
};

// @dynamic
// fix: https://github.com/ng-packagr/ng-packagr/issues/696
/**
 * Clase que gestiona todo lo relacionado con los Enum, pudiendo retornar el listado de Keys, Values o los dos juntos
 */
class Enum {
    /**
     * Método que retorna un Array de las Keys de un Enum, pasando como parámetro el tipo de Enum
     *
     * @param enumType Tipo de Enum
     */
    static getKeys(enumType) {
        return Object.keys(enumType);
    }
    /**
     * Método que retorna un Array de los Values de un Enum, pasando como parámetro el tipo de Enum
     *
     * @param enumType Tipo de Enum
     */
    static getValues(enumType) {
        return Object.keys(enumType).map((key) => enumType[key]);
    }
    /**
     * Método que retorna un map de <Key, Value> del tipo de Enum que se pase por parámetro
     *
     * @param enumType Tipo de Enum
     */
    static getMapList(enumType) {
        let mapList = new Map();
        Object.keys(enumType).forEach((key) => mapList.set(key, enumType[key]));
        return mapList;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { ArrayUtil, BlobUtil, Bool, CommonModule, DateTime, DateTimeFormat, Enum, Guid, KendoIntlService, KendoMessageService, LocaleFormat, LocalePipe, LocaleService, LocalizationModule, NgwkTooltipConfig, NgwkTooltipDirective, Num, ObjectWatcher, PopupComponent, PopupModule, Reflection, Str, TooltipModule, Type, UnitOfTime };

